import {common_utils} from "../common/common_utils";
import {slots_utils} from "../../../untils/slots_utils";
import {slots_tool} from "./slots_tool";

function game_5004()
{

}

game_5004.odd_map  = {
  "W":[0,0,25,25,25],
  "R":[0,0,20,20,20],
  "G":[0,0,15,15,15],
  "B":[0,0,12,12,12],
  "A":[0,0,10,10,10],
  "K":[0,0,8,8,8],
  "Q":[0,0,5,5,5],
  "J":[0,0,2,2,2],

};

game_5004.mul = 5

game_5004.readDataValue = function(this1,data)
{
  console.log("game_5004.readDataValue");
  this1.hasfree = false
  this1.hasbonuswin = false
  this1.hasext = true
  this1.mapList = []

  var rows = 3;
  var cols = 4;

  var mapJson = JSON.parse(data.detail.mapData)
  slots_utils.isExtTip(this1,mapJson)
  common_utils.readDataValue(this1,data);
  for (let i = 0; i < rows; i++)
  {
      for (let j = 0; j < cols; j++)
      {
          this1.mapList.push(mapJson.map[j * rows + i])
      }
  }
  this1.mapIndex = []
  this1.mapListDetail = {}
  this1.mapIndex.push(7)
  let mulNumStr = game_5004.get_value(this1.mapList,7);
  if (this1.checkLineWin_3(0, 1, 2))
  {
      this1.mapIndex.push(0)
      this1.mapIndex.push(1)
      this1.mapIndex.push(2)
      game_5004.read_win_data(this1.mapListDetail,game_5004.getMapIndex(this1.mapList,[0, 1, 2]));
  }

  if (this1.checkLineWin_3(4, 5, 6))
  {
      this1.mapIndex.push(4)
      this1.mapIndex.push(5)
      this1.mapIndex.push(6)
      game_5004.read_win_data(this1.mapListDetail,game_5004.getMapIndex(this1.mapList,[4, 5, 6]));
  }

  if (this1.checkLineWin_3(8, 9, 10))
  {
      this1.mapIndex.push(8)
      this1.mapIndex.push(9)
      this1.mapIndex.push(10)
      game_5004.read_win_data(this1.mapListDetail,game_5004.getMapIndex(this1.mapList,[8, 9, 10]));
  }

  if (this1.checkLineWin_3(0, 5, 10))
  {
      this1.mapIndex.push(0)
      this1.mapIndex.push(5)
      this1.mapIndex.push(10)
      game_5004.read_win_data(this1.mapListDetail,game_5004.getMapIndex(this1.mapList,[0, 5, 10]));
  }

  if (this1.checkLineWin_3(8, 5, 2))
  {
      this1.mapIndex.push(8)
      this1.mapIndex.push(5)
      this1.mapIndex.push(2)
      game_5004.read_win_data(this1.mapListDetail,game_5004.getMapIndex(this1.mapList,[8, 5, 2]));
  }

  let winValueList = [];
  let mulNum = parseInt(mulNumStr);
  slots_tool.setWinValue(winValueList,this1.mapListDetail,game_5004.odd_map,0);
  this1.winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),game_5004.mul,slots_tool.isFree(data),slots_tool.isExt(mapJson),mulNum);
}

game_5004.getMapIndex= function(mapList,indList)
{
    if(indList && indList.length < 3 )
    {
      return -1;
    }
    for (let i = 0; i < indList.length; i++)
    {
      let value = game_5004.get_value(mapList,indList[i]);
      if(value !== "W")
      {
          return value;
      }
    }
    let index = indList[0];
    return game_5004.get_value(mapList,index);
}

game_5004.get_value = function(mapList,index)
{
    if(index >= 0 && index < mapList.length)
    {
        return mapList[index];
    }
}

game_5004.read_win_data = function(mapDicDetail,key)
{
    var detail = mapDicDetail[key]
    if(detail)
    {
        detail.lines = detail.lines+1;
    }
    else
    {
        detail = {};
        detail.lines = 1
        detail.length = 3
        detail.key = key
    }
    mapDicDetail[key] = detail
}


export {
  game_5004
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5004.js